/**
 * Reforça o topo depois que a rotina termina de montar.
 *
 * O `scrollBehavior` de `app/router.options.ts` já resolve o caso normal, mas
 * ele age no documento e no instante da troca de rota. Duas situações escapam:
 *
 *   - a tela cresce DEPOIS, quando os dados chegam (o coletor busca quase tudo
 *     no `onMounted`), e o navegador pode reancorar a rolagem;
 *   - quem rola não é o documento e sim um container do layout — caso de
 *     telas que usam `overflow: auto` num bloco interno, onde o router não
 *     tem como saber que existe rolagem para zerar.
 *
 * Rodar no `page:finish` cobre os dois sem depender de qual é o caso.
 */
export default defineNuxtPlugin((nuxtApp) => {
	/** Containers de rolagem conhecidos dos layouts do coletor. */
	const CONTAINERS = ".layout-main, .layout-content, .menu-scroll-content, .menu-coletor";

	function irParaOTopo() {
		window.scrollTo({ top: 0, left: 0 });

		// `scrollTo` só age no documento; um bloco com `overflow` próprio guarda a
		// posição em `scrollTop` e precisa ser zerado à parte.
		document.querySelectorAll<HTMLElement>(CONTAINERS)
			.forEach((elemento) => {
				if (elemento.scrollTop !== 0) elemento.scrollTop = 0;
			});
	}

	nuxtApp.hook("page:finish", () => {
		irParaOTopo();
		// Uma segunda passada no próximo quadro: o conteúdo que só aparece depois
		// do primeiro render (tabelas, painéis de aba) muda a altura da página e
		// pode arrastar a rolagem junto.
		requestAnimationFrame(irParaOTopo);
	});
});
